import { isAxiosError } from "axios";
import { useState, useCallback } from "react";
import { serverRefusalMessage } from "@/lib/serverError";
import { showNotificationGlobal } from "stores/useNotificationStore";

export function useAccessUpdater<T>(
  apiCall: (entity: T, newAccess: string) => Promise<void>,
) {
  const [updatingIds, setUpdatingIds] = useState<Set<string>>(new Set());
  const [successIds, setSuccessIds] = useState<Set<string>>(new Set());

  const trigger = useCallback(
    async (id: string, entity: T, newAccess: string) => {
      setUpdatingIds((prev) => new Set(prev).add(id));
      try {
        await apiCall(entity, newAccess);
        setSuccessIds((prev) => new Set(prev).add(id));
        setTimeout(() => {
          setSuccessIds((prev) => {
            const next = new Set(prev);
            next.delete(id);
            return next;
          });
        }, 2000);
      } catch (e) {
        showNotificationGlobal(
          (isAxiosError(e) && serverRefusalMessage(e.response?.data)) ||
            "Failed to update access level",
          "error",
        );
      } finally {
        setUpdatingIds((prev) => {
          const next = new Set(prev);
          next.delete(id);
          return next;
        });
      }
    },
    [apiCall],
  );

  return { updatingIds, successIds, trigger };
}
